import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { getActiveUsers } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetActiveUsersResponse,
	GetActiveUsersRequest,
} from '@/modules/dashboard/type'

export default function useQueryGetActiveUsers(
	payload?: GetActiveUsersRequest,
	options?: Omit<
		UseQueryOptions<GetActiveUsersResponse>,
		'queryKey' | 'queryFn'
	>,
) {
	return useQuery<GetActiveUsersResponse>({
		queryKey: [DashboardKeys.ActiveUsers, payload],
		queryFn: () => getActiveUsers(payload),
		...options,
	})
}
